import { createContext, useCallback, useContext, useMemo, useState } from "react";

const GlobalModalContext = createContext(null);

export function GlobalModalProvider({ children }) {
  const [openModals, setOpenModals] = useState(() => new Set());

  const openModal = useCallback((name) => {
    setOpenModals((current) => new Set(current).add(name));
  }, []);

  const closeModal = useCallback((name) => {
    setOpenModals((current) => {
      const next = new Set(current);
      next.delete(name);
      return next;
    });
  }, []);

  const value = useMemo(
    () => ({
      openModal,
      closeModal,
      isModalOpen: (name) => openModals.has(name),
    }),
    [closeModal, openModal, openModals]
  );

  return <GlobalModalContext.Provider value={value}>{children}</GlobalModalContext.Provider>;
}

export function useGlobalModal() {
  const context = useContext(GlobalModalContext);
  if (!context) {
    throw new Error("useGlobalModal must be used inside GlobalModalProvider");
  }
  return context;
}
